import styled from 'styled-components'
import { theme } from '../../../../../styles/_variables'


export const PreviewCoverImage = styled.img`
  width: 160px;
  border-radius: 1px;
  margin-bottom: 24px;
`

export const Label = styled.h4`
  font-weight: 700;
  font-size: ${theme.fonts.size.subTitle};
  margin: 8px 0;
  color: ${theme.color.primaryColor};
`

export default PreviewCoverImage
